import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { SportType } from "../../../models/court/dto/court.dto";
import { UserFullProfileDto } from "../../../models/user/dto/user.dto";
import { GET_USER_BY_ID_QUERY_KEY } from "./useGetUser";

export type UpdateUserProfileInput = {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    /** Level 1–10; use with sportType for sport-specific level. */
    level?: number;
    sportType?: SportType;
    /** Admin only: when false, user cannot book courts. */
    canBookCourts?: boolean;
    /** Admin only: when false, user cannot use Pay Later. */
    canUsePayLater?: boolean;
};

export const useUpdateUserProfile = (
    userId: string,
    onSuccess?: (data: UserFullProfileDto) => void
) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["updateUserProfile", userId],
        mutationFn: (input: UpdateUserProfileInput) =>
            client.fetchApi<UserFullProfileDto, UpdateUserProfileInput>({
                endpoint: `users/${userId}/profile`,
                method: "PATCH",
                body: input,
            }),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: GET_USER_BY_ID_QUERY_KEY(userId) });
            onSuccess?.(data);
        },
    });
};
